'use strict';

import GoogleMap from './../common/GoogleMap';

export default function contactMap () {
    const CONTACT_MAP_SELECTOR = '.js-contact-map';

    let $contactMap = $(CONTACT_MAP_SELECTOR),
        $contactLocation = $('.js-contact-location'),
        $gMap,
        $gMapPosition;

    if (
        !$contactMap.length ||
        !$contactLocation.length
    ) {
        return;
    }

    let lat = $contactLocation.first().attr('data-lat');
    let lng = $contactLocation.first().attr('data-lng');

    let contactMap = new GoogleMap({
        mapSelector: CONTACT_MAP_SELECTOR,
        callback () {

            $gMap = this.$gMap;
            $gMapPosition = new google.maps.LatLng(lat, lng);

            $gMap.setCenter($gMapPosition);

            contactMap.setMarker({
                lat: lat,
                lng: lng,
                icon: {
                    url: '/v2/img/map-marker.png',
                    Size: new google.maps.Size(39, 30),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(18, 30)
                }
            });
        }
    });

    $contactLocation.on('click', function () {
        let $this = $(this);

        $contactLocation.removeClass('active');
        $this.addClass('active');

        contactMap.changeMarkerPosition({
            followFocus: true,
            idx: 0,
            lat: $this.attr('data-lat'),
            lng: $this.attr('data-lng'),
            icon: {
                url: '/v2/img/map-marker.png',
                Size: new google.maps.Size(39, 30),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(18, 30)
            }
        });
    });
}
